var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSameAthlete)?_c('SameAthleteState',{attrs:{"athlete":_vm.athlete}}):(_vm.isCollegeCoach)?_c('CollegeCoachState',{attrs:{"athlete":_vm.athlete}}):_c('DefaultState',{attrs:{"athlete":_vm.athlete}})
}
var staticRenderFns = []

export { render, staticRenderFns }